import { useMutation } from '@tanstack/react-query';
import { postCoupon } from '@wwe-portal/web/services/client/offer';

export const usePostCoupon = ({
  onError,
  onSuccess,
}: {
  onError: (error: unknown) => Promise<void>;
  onSuccess: (data: Awaited<ReturnType<typeof postCoupon>>) => Promise<void>;
}) => {
  return useMutation({ mutationFn: postCoupon, onSuccess, onError });
};
